import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-create-entity-button',
    styleUrl: './create-entity-button.component.scss',
    templateUrl: './create-entity-button.component.html',
})
export class CreateEntityButtonComponent {
    public readonly clicked = output<void>();
    public readonly disabled = input<boolean>(false);
    public readonly stopPropagation = input<boolean>(false);
    public readonly tooltipKey = input<string | undefined>(undefined);

    protected onClick(event: MouseEvent): void {
        if (this.disabled()) {
            return;
        }

        if (this.stopPropagation()) {
            event.stopPropagation();
        }

        this.clicked.emit();
    }
}
